// Filtres du suivi des camions de lots (lot 057) : lus dans l'adresse, envoyés
// au serveur. La liste, l'impression et l'envoi au responsable reçoivent les
// mêmes paramètres : ce que montre l'écran est ce qui s'imprime.

/** Codes du serveur (`core/lot_progress.py`, `models/sqlalchemy/attributed_lot.py`). */
export const ETAPES_LOT = [
  'ATTRIBUE',
  'CHARGEMENT',
  'EN_ROUTE',
  'DOUANE_MALI',
  'PARKING',
  'SORTI_DOUANE',
  'EN_LIVRAISON',
  'DEPOTE',
  'ANNULE',
];
export const RETOURS_LOT = ['A_RENDRE', 'EN_RETOUR', 'RENDU'];
export const ETATS_LIGNE = ['ATTRIBUE', 'CONFIRME'];
export const STATUTS_LOT = ['OUVERT', 'CLOS'];
/** Les quatre étapes qu'un partenaire annonce à la confirmation, dans l'ordre du parcours. */
export const ETAPES_CONFIRMATION = [
  'LOADING',
  'EN_ROUTE_TO_ENTRY_CUSTOMS',
  'AT_CUSTOMS_ENTRY',
  'CLEARED_CUSTOMS_ENTRY',
];

/** Nom de chaque filtre dans l'adresse : celui du serveur. */
export const NOMS_URL_SUIVI = {
  lot: 'lot_id',
  transporteur: 'transporter_id',
  etat: 'state',
  etape: 'stage',
  retour: 'return_status',
  statutLot: 'lot_status',
  q: 'q',
};

const dans = (liste, valeur) => (liste.includes(valeur) ? valeur : '');

/** Filtres de l'écran à partir de l'adresse ; toute valeur inattendue est ignorée. */
export const lireFiltresSuivi = (searchParams) => {
  const lire = (cle) => (searchParams.get(NOMS_URL_SUIVI[cle]) || '').trim();
  return {
    lot: lire('lot'),
    transporteur: lire('transporteur'),
    etat: dans(ETATS_LIGNE, lire('etat').toUpperCase()),
    etape: dans(ETAPES_LOT, lire('etape').toUpperCase()),
    retour: dans(RETOURS_LOT, lire('retour').toUpperCase()),
    statutLot: dans(STATUTS_LOT, lire('statutLot').toUpperCase()),
    q: lire('q'),
  };
};

/**
 * Paramètres de `GET /lots/trucks`, `GET /print/lot-trucks` et
 * `POST /print/lot-trucks/send`. Seuls les filtres actifs partent ; jamais la
 * pagination.
 */
export const parametresSuivi = (filtres) => {
  const p = {};
  if (filtres.lot) p.lot_id = filtres.lot;
  if (filtres.transporteur) p.transporter_id = filtres.transporteur;
  if (filtres.etat) p.state = filtres.etat;
  if (filtres.etape) p.stage = filtres.etape;
  if (filtres.retour) p.return_status = filtres.retour;
  if (filtres.statutLot) p.lot_status = filtres.statutLot;
  if (filtres.q) p.q = filtres.q;
  return p;
};

export const nombreFiltresSuivi = (filtres) => Object.keys(parametresSuivi(filtres)).length;

/** Change des filtres dans l'adresse : une valeur vide retire le paramètre. */
export const avecFiltresSuivi = (precedent, changements) => {
  const suivant = new URLSearchParams(precedent);
  Object.entries(changements).forEach(([cle, valeur]) => {
    const nom = NOMS_URL_SUIVI[cle];
    if (!nom) return;
    if (valeur === undefined || valeur === null || valeur === '' || valeur === 'all') suivant.delete(nom);
    else suivant.set(nom, String(valeur));
  });
  return suivant;
};

/** Tous les filtres retirés de l'adresse (la page et la taille sont gardées). */
export const sansFiltresSuivi = (precedent) => {
  const suivant = new URLSearchParams(precedent);
  Object.values(NOMS_URL_SUIVI).forEach((nom) => suivant.delete(nom));
  return suivant;
};

/** Reste à confirmer, d'après les compteurs du serveur. */
export const resteAConfirmer = (progress) =>
  Math.max(0, Number(progress?.unconfirmed ?? (progress?.attributed || 0) - (progress?.confirmed || 0)) || 0);

/** Le camion est-il encore à attribuer (pas de trajet) ? */
export const estAttribue = (ligne) => String(ligne?.state || '').toUpperCase() === 'ATTRIBUE';

/** Le camion peut-il partir en retour ? Il a dépoté et attend d'être rendu. */
export const peutPartirEnRetour = (ligne) => String(ligne?.return_status || '').toUpperCase() === 'A_RENDRE';

/** Le camion peut-il être marqué rendu ? Il est à rendre ou déjà en retour. */
export const peutEtreRendu = (ligne) =>
  ['A_RENDRE', 'EN_RETOUR'].includes(String(ligne?.return_status || '').toUpperCase());

/** Jour du jour, `AAAA-MM-JJ`, au fuseau de l'appareil (valeur d'un champ date). */
export const jourDuJour = (maintenant = new Date()) => {
  const mois = String(maintenant.getMonth() + 1).padStart(2, '0');
  const jour = String(maintenant.getDate()).padStart(2, '0');
  return `${maintenant.getFullYear()}-${mois}-${jour}`;
};
